module.exports = __webpack_public_path__ + "f6b5a73a1c8fc278522ea07181cadc36.svg";